import { validateCompanyDetailsSection } from 'mittweida/inquiry/steps/company/sections/companyDetails/validations';
import { validateCompletingCompanyDetailsSection } from 'mittweida/inquiry/steps/company/sections/completingCompanyDetailsSection/validations';
import { validateObjectInformationSection } from 'mittweida/inquiry/steps/financingNeed/sections/objectInformationSection/validations';
import { validateOtherProjectInformationSection } from 'mittweida/inquiry/steps/financingNeed/sections/otherProjectInformationSection/validations';
import { validateProjectCompositionSection } from 'mittweida/inquiry/steps/financingNeed/sections/projectCompositionSection/validation';
import { validateRoleSection } from 'mittweida/inquiry/steps/financingNeed/sections/roleSection/validation';
import { validateOtherFundingSection } from 'mittweida/inquiry/steps/fundingDetails/sections/otherFundingSection/validations';
import { validateContactPersonSection } from 'mittweida/inquiry/steps/userProfile/sections/contactPerson/validations';
import { validatePasswordSection } from 'mittweida/inquiry/steps/userProfile/sections/passwordSection/validations';
import { validateTermsAndConditionsSection } from 'mittweida/inquiry/steps/userProfile/sections/termsAndConditions/validations';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import { ValidationRecord } from 'new/form/common/types';
import { InquiryProcessValidations } from 'new/form/model';

const mittweidaCreateValidations: ValidationRecord<InquiryType.profiMittweida> = {
  financingNeedPage: {
    roleSection: (form, values, store, conditions) =>
      validateRoleSection(form, values, store, conditions),
    otherProjectInformation: (form, values, store, conditions) =>
      validateOtherProjectInformationSection(form, values, store, conditions),
    objectInformationSection: (form, values, store, conditions) =>
      validateObjectInformationSection(form, values, store, conditions),
    projectCompositionSection: (form, values, store, conditions) =>
      validateProjectCompositionSection(form, values, store, conditions),
  },
  companyDetailPage: {
    companyDetailsSection: (form, values, store, conditions) =>
      validateCompanyDetailsSection(form, values, store, conditions),
    completingCompanyDetailsSection: (form, values, store, conditions) =>
      validateCompletingCompanyDetailsSection(form, values, store, conditions),
  },
  fundingDetailsPage: {
    otherFundingSection: (form, values, store, conditions) =>
      validateOtherFundingSection(form, values, store, conditions),
  },
  userProfilePage: {
    contactPersonSection: (form, values, store, conditions) =>
      validateContactPersonSection(form, values, store, conditions),
    passwordSection: (form, values, store, conditions) =>
      validatePasswordSection(form, values, store, conditions),
    termsAndConditionsSection: (form, values, store, conditions) =>
      validateTermsAndConditionsSection(form, values, store, conditions),
  },
};

const mittweidaEditValidations: ValidationRecord<InquiryType.profiMittweida> = {
  ...mittweidaCreateValidations,
  userProfilePage: {
    contactPersonSection: () => true,
    passwordSection: () => true,
    termsAndConditionsSection: () => true,
  },
};

export const mittweidaValidations: InquiryProcessValidations<InquiryType.profiMittweida> = {
  create: mittweidaCreateValidations,
  editCustomer: mittweidaEditValidations,
  editOperation: mittweidaEditValidations,
};
